import {
  clearLocalPreference,
  readLocalPreference,
  writeLocalPreference,
} from '../local-preference.js'

/**
 * The /apply resume token's one home in the browser. Every read, store and
 * forget goes through these helpers so the key can never drift (a renamed
 * copy on either side would silently leave a long-lived bearer token behind).
 *
 * None of them throws. Storage-blocked browsers (in-app webviews with DOM
 * storage off, Safari blocking all cookies) throw from `localStorage`;
 * `lib/local-preference` owns that guard, so here a read that fails is null
 * and a store or forget that fails is a no-op. A caller that must survive a
 * full page load in such a browser has to carry the token itself.
 *
 * Lives apart from tokens.ts on purpose: that module is server-only (signing
 * secrets) and must not be pulled into the client bundle.
 */
const APPLY_TOKEN_STORAGE_KEY = 'bctci:apply-token'

/** The token this browser kept; null when none, or when storage is unreadable. */
export function readStoredApplyToken(): string | null {
  return readLocalPreference<string | null>(
    APPLY_TOKEN_STORAGE_KEY,
    (raw) => raw,
    null,
  )
}

/** Keep the token for a later visit; a refused write is a no-op. */
export function storeApplyToken(token: string): void {
  writeLocalPreference(APPLY_TOKEN_STORAGE_KEY, token)
}

/** Drop the token; a refused removal is a no-op (a blocked store held nothing). */
export function forgetStoredApplyToken(): void {
  clearLocalPreference(APPLY_TOKEN_STORAGE_KEY)
}
